module.exports = __webpack_public_path__ + "static/media/Alacuenta-logo.6ab2dee4.png";